import axios from 'axios';
import { CognitoIdentityServiceProvider, config } from 'aws-sdk';
import { Auth } from 'aws-amplify';
import { COMMON_API_URL } from '../utils/common';

const cognitoIdentityServiceProvider = new CognitoIdentityServiceProvider({
    region: "ap-south-1",
});
  
// const refreshAccessToken = async (path: string) => {



// Create a new instance of Axios with a base URL
const axiosInstance = axios.create({
  baseURL: COMMON_API_URL,
// headers: {
//     'Authorization': `Bearer ${localStorage.getItem('Token')}`
//     }
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.headers) {
      const token = localStorage.getItem('Token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

try{
  axiosInstance.interceptors.response.use(
    response => {
      return response.data},
    async error => {        
      if ( error.response.status === 401 ){
        const originalRequest = error.config;    
        if (error && !originalRequest._retry) {
          try{
            const session = await Auth.currentSession();
            const refreshToken = session.getRefreshToken().getToken();
            // localStorage.setItem('refreshToken', 'abcdefgh')
            
            const params: any = {
              AuthFlow: 'REFRESH_TOKEN_AUTH',
              ClientId: 'qf4m3jr6abvr2i5opelhjsejg',
              AuthParameters: {
                  REFRESH_TOKEN: refreshToken,
              },
          };
            originalRequest._retry = true;
            const response = await cognitoIdentityServiceProvider.initiateAuth(params).promise();        
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response && response.AuthenticationResult && response.AuthenticationResult.IdToken || ''}`
            localStorage.setItem('Token', `${response && response.AuthenticationResult && response.AuthenticationResult.IdToken}` || '')   
            originalRequest.headers.Authorization = `Bearer ${response && response.AuthenticationResult && response.AuthenticationResult.IdToken}` || ''
            return axiosInstance(originalRequest);
          }
          catch(e){
            await Auth.signOut();
            window.location.href = '/login'; 
          }
        }
      if ( error.response.status === 403 ){
        console.log('redirecttologin');
      }
      }
      // Do something with the response error
      return Promise.reject(error);
    }
  );
}catch(e: any){
  console.log('exception', e);
  
}

export default axiosInstance;